import React from "react";
import classNames from "classnames";

import PaginationItem from "./PaginationItem";

interface Props {
  pageCount: number;
  pageRange?: number;
  selectedPage?: number;
  handleSelectPage: (index: number) => void;
}

const Pagination: React.FC<Props> = (props: Props): JSX.Element => {
  const { pageCount, pageRange = 6, selectedPage = 0, handleSelectPage } = props;

  let maxPagesToDisplay = pageRange;
  if (pageCount < pageRange) {
    maxPagesToDisplay = pageCount;
  }

  // Determine the starting page index to display
  const midpoint = Math.floor(maxPagesToDisplay / 2);
  let startingIndex = selectedPage - midpoint;
  if (selectedPage < midpoint) {
    startingIndex = 0;
  } else if (selectedPage >= pageCount - midpoint) {
    startingIndex = pageCount - maxPagesToDisplay;
  }

  const paginationItems = [...Array(maxPagesToDisplay)].map((_, i) => {
    const pageIndex = i + startingIndex;

    return (
      <PaginationItem
        key={`page-${pageIndex}`}
        isSelectedPage={selectedPage === pageIndex}
        pageIndex={pageIndex}
        handleSelectPage={handleSelectPage}
      />
    );
  });

  const navigateToNext = (): void => {
    if (selectedPage < pageCount - 1) {
      handleSelectPage(selectedPage + 1);
    }
  };
  const navigateToPrevious = (): void => {
    if (selectedPage > 0) {
      handleSelectPage(selectedPage - 1);
    }
  };

  const previousPageClassList = classNames("caprx-pagination-item caprx-pagination-item-previous", {
    "caprx-pagination-item-disabled": selectedPage === 0,
  });

  const nextPageClassList = classNames("caprx-pagination-item caprx-pagination-item-next", {
    "caprx-pagination-item-disabled": selectedPage === pageCount - 1,
  });

  return (
    <div className="caprx-pagination">
      <ul className="caprx-pagination-list">
        <li className={previousPageClassList}>
          <a className="caprx-pagination-link" onClick={navigateToPrevious} tabIndex={0}>
            <span className="caprx-icon-inputarrowcaretleft" />
          </a>
        </li>
        {paginationItems}
        <li className={nextPageClassList}>
          <a className="caprx-pagination-link" onClick={navigateToNext} tabIndex={0}>
            <span className="caprx-icon-inputarrowcaretright" />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
